import { Building } from "lucide-react";
import { Property } from "../../types";
import { Box, Typography } from "@mui/material";
import AddSubProperty from "./add-sub-property";

export default function SubPropertiesEmptyState({
  property,
  trackTypeName,
}: {
  property: Property;
  trackTypeName?: string;
}) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        gap: theme.nawy.spacing.sm,
        background: theme.nawy.colors.semantic.layer.primary,
        borderRadius: theme.nawy.radius.xl,
      })}
    >
      <Building size={24} />
      <Typography
        sx={(theme) => theme.nawy.typography.english.variants.headline.sm}
      >
        No sub-properties yet
      </Typography>
      <Typography
        sx={(theme) => theme.nawy.typography.english.variants.body.md.regular}
      >
        This property has no sub-properties yet.
      </Typography>

      <AddSubProperty property={property} trackTypeName={trackTypeName} />
    </Box>
  );
}
